export enum columnNodeKeys {
  COLUMN1 = 'col1Nodes',
  COLUMN2 = 'col2Nodes',
  COLUMN3 = 'col3Nodes',
  COLUMN4 = 'col4Nodes',
}

export enum NodeType {
  PRODUCT_FLOW_MAP_NODE = 'customNode',
}

export enum HandleTypes {
  TARGET = 'target',
  SOURCE = 'source',
}

export enum ProductMapRoots {
  PRODUCT_OVERVIEW_ROOT = 'productOverviewRoot',
  PRODUCT_MAP_DOWNLOAD_ROOT = 'productMapDownload',
  PRODUCT_CREATION_FLOW_ROOT = 'productCreationFlow',
}
